// Fall back list of supported time zones. It should be updated manually when the BE deploys a new list.
// This list is only used as a fallback in case at app load the call to fetch BE time zones fails
export const FALLBACK_ALLOWED_SUPPORTED_TIMEZONES_LIST = [
    'Africa/Abidjan',
    'Africa/Accra',
    'Africa/Algiers',
    'Africa/Bissau',
    'Africa/Cairo',
    'Africa/Casablanca',
    'Africa/Ceuta',
    'Africa/El_Aaiun',
    'Africa/Johannesburg',
    'Africa/Juba',
    'Africa/Khartoum',
    'Africa/Lagos',
    'Africa/Maputo',
    'Africa/Monrovia',
    'Africa/Nairobi',
    'Africa/Ndjamena',
    'Africa/Sao_Tome',
    'Africa/Tripoli',
    'Africa/Tunis',
    'Africa/Windhoek',
    'America/Adak',
    'America/Anchorage',
    'America/Araguaina',
    'America/Argentina/Buenos_Aires',
    'America/Argentina/Catamarca',
    'America/Argentina/Cordoba',
    'America/Argentina/Jujuy',
    'America/Argentina/La_Rioja',
    'America/Argentina/Mendoza',
    'America/Argentina/Rio_Gallegos',
    'America/Argentina/Salta',
    'America/Argentina/San_Juan',
    'America/Argentina/San_Luis',
    'America/Argentina/Tucuman',
    'America/Argentina/Ushuaia',
    'America/Asuncion',
    'America/Atikokan',
    'America/Bahia',
    'America/Bahia_Banderas',
    'America/Barbados',
    'America/Belem',
    'America/Belize',
    'America/Blanc-Sablon',
    'America/Boa_Vista',
    'America/Bogota',
    'America/Boise',
    'America/Cambridge_Bay',
    'America/Campo_Grande',
    'America/Cancun',
    'America/Caracas',
    'America/Cayenne',
    'America/Chicago',
    'America/Chihuahua',
    'America/Costa_Rica',
    'America/Creston',
    'America/Cuiaba',
    'America/Curacao',
    'America/Danmarkshavn',
    'America/Dawson',
    'America/Dawson_Creek',
    'America/Denver',
    'America/Detroit',
    'America/Edmonton',
    'America/Eirunepe',
    'America/El_Salvador',
    'America/Fort_Nelson',
    'America/Fortaleza',
    'America/Glace_Bay',
    'America/Goose_Bay',
    'America/Grand_Turk',
    'America/Guatemala',
    'America/Guayaquil',
    'America/Guyana',
    'America/Halifax',
    'America/Havana',
    'America/Hermosillo',
    'America/Indiana/Knox',
    'America/Indiana/Marengo',
    'America/Indiana/Petersburg',
    'America/Indiana/Tell_City',
    'America/Indiana/Vevay',
    'America/Indiana/Vincennes',
    'America/Indiana/Winamac',
    'America/Inuvik',
    'America/Iqaluit',
    'America/Jamaica',
    'America/Juneau',
    'America/Kentucky/Louisville',
    'America/Kentucky/Monticello',
    'America/La_Paz',
    'America/Lima',
    'America/Los_Angeles',
    'America/Maceio',
    'America/Managua',
    'America/Manaus',
    'America/Martinique',
    'America/Matamoros',
    'America/Mazatlan',
    'America/Menominee',
    'America/Merida',
    'America/Metlakatla',
    'America/Mexico_City',
    'America/Miquelon',
    'America/Moncton',
    'America/Monterrey',
    'America/Montevideo',
    'America/Nassau',
    'America/New_York',
    'America/Nipigon',
    'America/Nome',
    'America/Noronha',
    'America/North_Dakota/Beulah',
    'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem',
    'America/Ojinaga',
    'America/Panama',
    'America/Pangnirtung',
    'America/Paramaribo',
    'America/Phoenix',
    'America/Port-au-Prince',
    'America/Port_of_Spain',
    'America/Porto_Velho',
    'America/Puerto_Rico',
    'America/Punta_Arenas',
    'America/Rainy_River',
    'America/Rankin_Inlet',
    'America/Recife',
    'America/Regina',
    'America/Resolute',
    'America/Rio_Branco',
    'America/Santarem',
    'America/Santiago',
    'America/Santo_Domingo',
    'America/Sao_Paulo',
    'America/Scoresbysund',
    'America/Sitka',
    'America/St_Johns',
    'America/Swift_Current',
    'America/Tegucigalpa',
    'America/Thule',
    'America/Thunder_Bay',
    'America/Tijuana',
    'America/Toronto',
    'America/Vancouver',
    'America/Whitehorse',
    'America/Winnipeg',
    'America/Yakutat',
    'America/Yellowknife',
    'Antarctica/Casey',
    'Antarctica/Davis',
    'Antarctica/DumontDUrville',
    'Antarctica/Macquarie',
    'Antarctica/Mawson',
    'Antarctica/Palmer',
    'Antarctica/Rothera',
    'Antarctica/Syowa',
    'Antarctica/Troll',
    'Antarctica/Vostok',
    'Asia/Almaty',
    'Asia/Amman',
    'Asia/Anadyr',
    'Asia/Aqtau',
    'Asia/Aqtobe',
    'Asia/Ashgabat',
    'Asia/Atyrau',
    'Asia/Baghdad',
    'Asia/Baku',
    'Asia/Bangkok',
    'Asia/Barnaul',
    'Asia/Beirut',
    'Asia/Bishkek',
    'Asia/Brunei',
    'Asia/Chita',
    'Asia/Choibalsan',
    'Asia/Colombo',
    'Asia/Damascus',
    'Asia/Dhaka',
    'Asia/Dili',
    'Asia/Dubai',
    'Asia/Dushanbe',
    'Asia/Famagusta',
    'Asia/Gaza',
    'Asia/Hebron',
    'Asia/Ho_Chi_Minh',
    'Asia/Hong_Kong',
    'Asia/Hovd',
    'Asia/Irkutsk',
    'Asia/Jakarta',
    'Asia/Jayapura',
    'Asia/Jerusalem',
    'Asia/Kabul',
    'Asia/Kamchatka',
    'Asia/Karachi',
    'Asia/Kathmandu',
    'Asia/Khandyga',
    'Asia/Kolkata',
    'Asia/Krasnoyarsk',
    'Asia/Kuala_Lumpur',
    'Asia/Kuching',
    'Asia/Macau',
    'Asia/Magadan',
    'Asia/Makassar',
    'Asia/Manila',
    'Asia/Nicosia',
    'Asia/Novokuznetsk',
    'Asia/Novosibirsk',
    'Asia/Omsk',
    'Asia/Oral',
    'Asia/Pontianak',
    'Asia/Pyongyang',
    'Asia/Qatar',
    'Asia/Qostanay',
    'Asia/Qyzylorda',
    'Asia/Riyadh',
    'Asia/Sakhalin',
    'Asia/Samarkand',
    'Asia/Seoul',
    'Asia/Shanghai',
    'Asia/Srednekolymsk',
    'Asia/Taipei',
    'Asia/Tashkent',
    'Asia/Tbilisi',
    'Asia/Tehran',
    'Asia/Thimphu',
    'Asia/Tokyo',
    'Asia/Tomsk',
    'Asia/Ulaanbaatar',
    'Asia/Urumqi',
    'Asia/Ust-Nera',
    'Asia/Vladivostok',
    'Asia/Yakutsk',
    'Asia/Yekaterinburg',
    'Asia/Yerevan',
    'Atlantic/Azores',
    'Atlantic/Bermuda',
    'Atlantic/Canary',
    'Atlantic/Cape_Verde',
    'Atlantic/Faroe',
    'Atlantic/Madeira',
    'Atlantic/Reykjavik',
    'Atlantic/South_Georgia',
    'Atlantic/Stanley',
    'Australia/Adelaide',
    'Australia/Brisbane',
    'Australia/Broken_Hill',
    'Australia/Darwin',
    'Australia/Eucla',
    'Australia/Hobart',
    'Australia/Lindeman',
    'Australia/Lord_Howe',
    'Australia/Melbourne',
    'Australia/Perth',
    'Australia/Sydney',
    'Europe/Amsterdam',
    'Europe/Andorra',
    'Europe/Astrakhan',
    'Europe/Athens',
    'Europe/Belgrade',
    'Europe/Berlin',
    'Europe/Brussels',
    'Europe/Bucharest',
    'Europe/Budapest',
    'Europe/Chisinau',
    'Europe/Copenhagen',
    'Europe/Dublin',
    'Europe/Gibraltar',
    'Europe/Helsinki',
    'Europe/Istanbul',
    'Europe/Kaliningrad',
    'Europe/Kiev',
    'Europe/Kirov',
    'Europe/Lisbon',
    'Europe/London',
    'Europe/Luxembourg',
    'Europe/Madrid',
    'Europe/Malta',
    'Europe/Minsk',
    'Europe/Monaco',
    'Europe/Moscow',
    'Europe/Oslo',
    'Europe/Paris',
    'Europe/Prague',
    'Europe/Riga',
    'Europe/Rome',
    'Europe/Samara',
    'Europe/Saratov',
    'Europe/Simferopol',
    'Europe/Sofia',
    'Europe/Stockholm',
    'Europe/Tallinn',
    'Europe/Tirane',
    'Europe/Ulyanovsk',
    'Europe/Uzhgorod',
    'Europe/Vienna',
    'Europe/Vilnius',
    'Europe/Volgograd',
    'Europe/Warsaw',
    'Europe/Zaporozhye',
    'Europe/Zurich',
    'Indian/Chagos',
    'Indian/Christmas',
    'Indian/Cocos',
    'Indian/Kerguelen',
    'Indian/Mahe',
    'Indian/Maldives',
    'Indian/Mauritius',
    'Indian/Reunion',
    'Pacific/Apia',
    'Pacific/Auckland',
    'Pacific/Bougainville',
    'Pacific/Chatham',
    'Pacific/Chuuk',
    'Pacific/Easter',
    'Pacific/Efate',
    'Pacific/Fakaofo',
    'Pacific/Fiji',
    'Pacific/Galapagos',
    'Pacific/Gambier',
    'Pacific/Guadalcanal',
    'Pacific/Guam',
    'Pacific/Honolulu',
    'Pacific/Kiritimati',
    'Pacific/Kosrae',
    'Pacific/Kwajalein',
    'Pacific/Majuro',
    'Pacific/Marquesas',
    'Pacific/Nauru',
    'Pacific/Niue',
    'Pacific/Norfolk',
    'Pacific/Noumea',
    'Pacific/Pago_Pago',
    'Pacific/Palau',
    'Pacific/Pitcairn',
    'Pacific/Pohnpei',
    'Pacific/Port_Moresby',
    'Pacific/Rarotonga',
    'Pacific/Tahiti',
    'Pacific/Tarawa',
    'Pacific/Tongatapu',
    'UTC',
];

/*
 * The list of timezones supported by FE is given by the function listTimezones(),
 * which returns the timezones in the 2019c iana database. That database is backward-compatible
 * (the list of timezones keeps changing because humans keep making crazy irrational decisions).
 * The API does not like backward-compatibility though, and they only support some of those
 * timezones (loosely based on https://www.php.net/manual/en/timezones.php). The list of timezones
 * recognized by FE but not supported by BE are the ones that serve as entries for the object below.
 * The value for each entry is the supported timezone we will re-direct to
 */
export const unsupportedTimezoneLinks: { [key: string]: string } = {
    'America/Indiana/Indianapolis': 'America/New_York',
    'America/Fort_Wayne': 'America/New_York',
    'America/Godthab': 'Atlantic/Stanley',
    'Asia/Singapore': 'Asia/Shanghai',
    'Asia/Rangoon': 'Indian/Cocos',
    'Asia/Yangon': 'Indian/Cocos',
    'Pacific/Funafuti': 'Asia/Kamchatka',
    'Pacific/Wake': 'Asia/Kamchatka',
    'Pacific/Wallis': 'Asia/Kamchatka',
    'Pacific/Enderbury': 'Pacific/Fakaofo',
    CET: 'Europe/Paris',
    CST6CDT: 'America/Chicago',
    EET: 'Europe/Istanbul',
    EST: 'America/New_York',
    EST5EDT: 'America/New_York',
    'Etc/GMT+1': 'Atlantic/Cape_Verde',
    'Etc/GMT+10': 'Pacific/Tahiti',
    'Etc/GMT+11': 'Pacific/Niue',
    'Etc/GMT+12': 'Pacific/Niue', // no canonical timezone exists for GMT+12
    'Etc/GMT+2': 'America/Noronha',
    'Etc/GMT+3': 'America/Sao_Paulo',
    'Etc/GMT+4': 'America/Caracas',
    'Etc/GMT+5': 'America/Lima',
    'Etc/GMT+6': 'America/Managua',
    'Etc/GMT+7': 'America/Phoenix',
    'Etc/GMT+8': 'Pacific/Pitcairn',
    'Etc/GMT+9': 'Pacific/Gambier',
    'Etc/GMT-0': 'UTC',
    'Etc/GMT-1': 'Europe/Paris',
    'Etc/GMT-10': 'Australia/Brisbane',
    'Etc/GMT-11': 'Australia/Sydney',
    'Etc/GMT-12': 'Pacific/Auckland',
    'Etc/GMT-13': 'Pacific/Fakaofo',
    'Etc/GMT-14': 'Pacific/Kiritimati',
    'Etc/GMT-2': 'Africa/Cairo',
    'Etc/GMT-3': 'Asia/Baghdad',
    'Etc/GMT-4': 'Asia/Dubai',
    'Etc/GMT-5': 'Asia/Tashkent',
    'Etc/GMT-6': 'Asia/Dhaka',
    'Etc/GMT-7': 'Asia/Jakarta',
    'Etc/GMT-8': 'Asia/Shanghai',
    'Etc/GMT-9': 'Asia/Tokyo',
    'Etc/UTC': 'UTC',
    HST: 'Pacific/Honolulu',
    MET: 'Europe/Paris',
    MST: 'Europe/Paris',
    MST7MDT: 'America/Denver',
    PST8PDT: 'America/Los_Angeles',
    WET: 'Europe/Lisbon',
    // 2022g update
    'America/Ciudad_Juarez': 'America/Ojinaga',
    'America/Nuuk': 'America/Scoresbysund',
    'Europe/Kyiv': 'Europe/Kiev',
    'Australia/Currie': 'Australia/Hobart',
    'Pacific/Kanton': 'Pacific/Fakaofo',
};

/**
 * Map of "equivalent" time zones. Our definition of equivalence is as follows:
 *
 * Two time zones are considered equivalent if their UTC offsets and their respective changes (due to DST or re-definitions)
 * match in the period 2010 - 2030. This map is provided by the back-end so that all clients are aligned with it
 */
export const MANUAL_TIMEZONE_EQUIVALENCE: { [key: string]: string } = {
    'Africa/Abidjan': 'Africa/Abidjan',
    'Africa/Accra': 'Africa/Abidjan',
    'Africa/Bissau': 'Africa/Abidjan',
    'Africa/Monrovia': 'Africa/Abidjan',
    'America/Danmarkshavn': 'Africa/Abidjan',
    'Atlantic/Reykjavik': 'Africa/Abidjan',
    UTC: 'Africa/Abidjan',
    'Africa/Algiers': 'Africa/Algiers',
    'Africa/Lagos': 'Africa/Algiers',
    'Africa/Ndjamena': 'Africa/Algiers',
    'Africa/Tunis': 'Africa/Algiers',
    'Africa/Cairo': 'Africa/Cairo',
    'Africa/Casablanca': 'Africa/Casablanca',
    'Africa/El_Aaiun': 'Africa/Casablanca',
    'Africa/Ceuta': 'Africa/Ceuta',
    'Europe/Amsterdam': 'Africa/Ceuta',
    'Europe/Andorra': 'Africa/Ceuta',
    'Europe/Belgrade': 'Africa/Ceuta',
    'Europe/Berlin': 'Africa/Ceuta',
    'Europe/Brussels': 'Africa/Ceuta',
    'Europe/Budapest': 'Africa/Ceuta',
    'Europe/Copenhagen': 'Africa/Ceuta',
    'Europe/Gibraltar': 'Africa/Ceuta',
    'Europe/Luxembourg': 'Africa/Ceuta',
    'Europe/Madrid': 'Africa/Ceuta',
    'Europe/Malta': 'Africa/Ceuta',
    'Europe/Monaco': 'Africa/Ceuta',
    'Europe/Oslo': 'Africa/Ceuta',
    'Europe/Paris': 'Africa/Ceuta',
    'Europe/Prague': 'Africa/Ceuta',
    'Europe/Rome': 'Africa/Ceuta',
    'Europe/Stockholm': 'Africa/Ceuta',
    'Europe/Tirane': 'Africa/Ceuta',
    'Europe/Vienna': 'Africa/Ceuta',
    'Europe/Warsaw': 'Africa/Ceuta',
    'Europe/Zurich': 'Africa/Ceuta',
    'Africa/Johannesburg': 'Africa/Johannesburg',
    'Africa/Maputo': 'Africa/Johannesburg',
    'Africa/Juba': 'Africa/Juba',
    'Africa/Nairobi': 'Africa/Juba',
    'Antarctica/Syowa': 'Africa/Juba',
    'Asia/Baghdad': 'Africa/Juba',
    'Asia/Qatar': 'Africa/Juba',
    'Asia/Riyadh': 'Africa/Juba',
    'Africa/Khartoum': 'Africa/Khartoum',
    'Africa/Sao_Tome': 'Africa/Sao_Tome',
    'Africa/Tripoli': 'Africa/Tripoli',
    'Africa/Windhoek': 'Africa/Windhoek',
    'America/Adak': 'America/Adak',
    'America/Anchorage': 'America/Anchorage',
    'America/Juneau': 'America/Anchorage',
    'America/Nome': 'America/Anchorage',
    'America/Sitka': 'America/Anchorage',
    'America/Yakutat': 'America/Anchorage',
    'America/Araguaina': 'America/Araguaina',
    'America/Argentina/Buenos_Aires': 'America/Argentina/Buenos_Aires',
    'America/Argentina/Catamarca': 'America/Argentina/Buenos_Aires',
    'America/Argentina/Cordoba': 'America/Argentina/Buenos_Aires',
    'America/Argentina/Jujuy': 'America/Argentina/Buenos_Aires',
    'America/Argentina/La_Rioja': 'America/Argentina/Buenos_Aires',
    'America/Argentina/Mendoza': 'America/Argentina/Buenos_Aires',
    'America/Argentina/Rio_Gallegos': 'America/Argentina/Buenos_Aires',
    'America/Argentina/Salta': 'America/Argentina/Buenos_Aires',
    'America/Argentina/San_Juan': 'America/Argentina/Buenos_Aires',
    'America/Argentina/San_Luis': 'America/Argentina/Buenos_Aires',
    'America/Argentina/Tucuman': 'America/Argentina/Buenos_Aires',
    'America/Argentina/Ushuaia': 'America/Argentina/Buenos_Aires',
    'America/Belem': 'America/Argentina/Buenos_Aires',
    'America/Cayenne': 'America/Argentina/Buenos_Aires',
    'America/Fortaleza': 'America/Argentina/Buenos_Aires',
    'America/Maceio': 'America/Argentina/Buenos_Aires',
    'America/Paramaribo': 'America/Argentina/Buenos_Aires',
    'America/Recife': 'America/Argentina/Buenos_Aires',
    'America/Santarem': 'America/Argentina/Buenos_Aires',
    'Antarctica/Rothera': 'America/Argentina/Buenos_Aires',
    'America/Asuncion': 'America/Asuncion',
    'America/Atikokan': 'America/Atikokan',
    'America/Bogota': 'America/Atikokan',
    'America/Guayaquil': 'America/Atikokan',
    'America/Jamaica': 'America/Atikokan',
    'America/Lima': 'America/Atikokan',
    'America/Panama': 'America/Atikokan',
    'America/Bahia': 'America/Bahia',
    'America/Bahia_Banderas': 'America/Bahia_Banderas',
    'America/Barbados': 'America/Barbados',
    'America/Blanc-Sablon': 'America/Barbados',
    'America/Boa_Vista': 'America/Barbados',
    'America/Curacao': 'America/Barbados',
    'America/Guyana': 'America/Barbados',
    'America/La_Paz': 'America/Barbados',
    'America/Manaus': 'America/Barbados',
    'America/Martinique': 'America/Barbados',
    'America/Port_of_Spain': 'America/Barbados',
    'America/Porto_Velho': 'America/Barbados',
    'America/Puerto_Rico': 'America/Barbados',
    'America/Santo_Domingo': 'America/Barbados',
    'America/Belize': 'America/Belize',
    'America/Costa_Rica': 'America/Belize',
    'America/El_Salvador': 'America/Belize',
    'America/Guatemala': 'America/Belize',
    'America/Managua': 'America/Belize',
    'America/Regina': 'America/Belize',
    'America/Swift_Current': 'America/Belize',
    'America/Tegucigalpa': 'America/Belize',
    'Pacific/Galapagos': 'America/Belize',
    'America/Boise': 'America/Boise',
    'America/Cambridge_Bay': 'America/Boise',
    'America/Denver': 'America/Boise',
    'America/Edmonton': 'America/Boise',
    'America/Inuvik': 'America/Boise',
    'America/Ojinaga': 'America/Boise',
    'America/Yellowknife': 'America/Boise',
    'America/Campo_Grande': 'America/Campo_Grande',
    'America/Cuiaba': 'America/Campo_Grande',
    'America/Cancun': 'America/Cancun',
    'America/Caracas': 'America/Caracas',
    'America/Chicago': 'America/Chicago',
    'America/Indiana/Knox': 'America/Chicago',
    'America/Indiana/Tell_City': 'America/Chicago',
    'America/Matamoros': 'America/Chicago',
    'America/Menominee': 'America/Chicago',
    'America/North_Dakota/Center': 'America/Chicago',
    'America/North_Dakota/New_Salem': 'America/Chicago',
    'America/Rainy_River': 'America/Chicago',
    'America/Rankin_Inlet': 'America/Chicago',
    'America/Resolute': 'America/Chicago',
    'America/Winnipeg': 'America/Chicago',
    'America/Chihuahua': 'America/Chihuahua',
    'America/Mazatlan': 'America/Chihuahua',
    'America/Creston': 'America/Creston',
    'America/Dawson_Creek': 'America/Creston',
    'America/Hermosillo': 'America/Creston',
    'America/Phoenix': 'America/Creston',
    'America/Dawson': 'America/Dawson',
    'America/Whitehorse': 'America/Dawson',
    'America/Detroit': 'America/Detroit',
    'America/Indiana/Marengo': 'America/Detroit',
    'America/Indiana/Petersburg': 'America/Detroit',
    'America/Indiana/Vevay': 'America/Detroit',
    'America/Indiana/Vincennes': 'America/Detroit',
    'America/Indiana/Winamac': 'America/Detroit',
    'America/Iqaluit': 'America/Detroit',
    'America/Kentucky/Louisville': 'America/Detroit',
    'America/Kentucky/Monticello': 'America/Detroit',
    'America/Nassau': 'America/Detroit',
    'America/New_York': 'America/Detroit',
    'America/Nipigon': 'America/Detroit',
    'America/Pangnirtung': 'America/Detroit',
    'America/Thunder_Bay': 'America/Detroit',
    'America/Toronto': 'America/Detroit',
    'America/Eirunepe': 'America/Eirunepe',
    'America/Rio_Branco': 'America/Eirunepe',
    'America/Fort_Nelson': 'America/Fort_Nelson',
    'America/Glace_Bay': 'America/Glace_Bay',
    'America/Halifax': 'America/Glace_Bay',
    'America/Moncton': 'America/Glace_Bay',
    'America/Thule': 'America/Glace_Bay',
    'Atlantic/Bermuda': 'America/Glace_Bay',
    'America/Goose_Bay': 'America/Goose_Bay',
    'America/Grand_Turk': 'America/Grand_Turk',
    'America/Havana': 'America/Havana',
    'America/Los_Angeles': 'America/Los_Angeles',
    'America/Tijuana': 'America/Los_Angeles',
    'America/Vancouver': 'America/Los_Angeles',
    'America/Merida': 'America/Merida',
    'America/Mexico_City': 'America/Merida',
    'America/Monterrey': 'America/Merida',
    'America/Metlakatla': 'America/Metlakatla',
    'America/Miquelon': 'America/Miquelon',
    'America/Montevideo': 'America/Montevideo',
    'America/Noronha': 'America/Noronha',
    'Atlantic/South_Georgia': 'America/Noronha',
    'America/North_Dakota/Beulah': 'America/North_Dakota/Beulah',
    'America/Port-au-Prince': 'America/Port-au-Prince',
    'America/Punta_Arenas': 'America/Punta_Arenas',
    'Antarctica/Palmer': 'America/Punta_Arenas',
    'America/Santiago': 'America/Santiago',
    'America/Sao_Paulo': 'America/Sao_Paulo',
    'America/Scoresbysund': 'America/Scoresbysund',
    'Atlantic/Azores': 'America/Scoresbysund',
    'America/St_Johns': 'America/St_Johns',
    'Antarctica/Casey': 'Antarctica/Casey',
    'Antarctica/Davis': 'Antarctica/Davis',
    'Antarctica/DumontDUrville': 'Antarctica/DumontDUrville',
    'Australia/Brisbane': 'Antarctica/DumontDUrville',
    'Australia/Lindeman': 'Antarctica/DumontDUrville',
    'Pacific/Chuuk': 'Antarctica/DumontDUrville',
    'Pacific/Guam': 'Antarctica/DumontDUrville',
    'Pacific/Port_Moresby': 'Antarctica/DumontDUrville',
    'Antarctica/Macquarie': 'Antarctica/Macquarie',
    'Antarctica/Mawson': 'Antarctica/Mawson',
    'Asia/Aqtau': 'Antarctica/Mawson',
    'Asia/Aqtobe': 'Antarctica/Mawson',
    'Asia/Ashgabat': 'Antarctica/Mawson',
    'Asia/Atyrau': 'Antarctica/Mawson',
    'Asia/Dushanbe': 'Antarctica/Mawson',
    'Asia/Karachi': 'Antarctica/Mawson',
    'Asia/Oral': 'Antarctica/Mawson',
    'Asia/Samarkand': 'Antarctica/Mawson',
    'Asia/Tashkent': 'Antarctica/Mawson',
    'Indian/Kerguelen': 'Antarctica/Mawson',
    'Indian/Maldives': 'Antarctica/Mawson',
    'Antarctica/Troll': 'Antarctica/Troll',
    'Antarctica/Vostok': 'Antarctica/Vostok',
    'Asia/Almaty': 'Antarctica/Vostok',
    'Asia/Bishkek': 'Antarctica/Vostok',
    'Asia/Dhaka': 'Antarctica/Vostok',
    'Asia/Qostanay': 'Antarctica/Vostok',
    'Asia/Thimphu': 'Antarctica/Vostok',
    'Asia/Urumqi': 'Antarctica/Vostok',
    'Indian/Chagos': 'Antarctica/Vostok',
    'Asia/Amman': 'Asia/Amman',
    'Asia/Anadyr': 'Asia/Anadyr',
    'Asia/Kamchatka': 'Asia/Anadyr',
    'Asia/Baku': 'Asia/Baku',
    'Asia/Bangkok': 'Asia/Bangkok',
    'Asia/Ho_Chi_Minh': 'Asia/Bangkok',
    'Asia/Jakarta': 'Asia/Bangkok',
    'Asia/Pontianak': 'Asia/Bangkok',
    'Indian/Christmas': 'Asia/Bangkok',
    'Asia/Barnaul': 'Asia/Barnaul',
    'Asia/Beirut': 'Asia/Beirut',
    'Asia/Brunei': 'Asia/Brunei',
    'Asia/Hong_Kong': 'Asia/Brunei',
    'Asia/Kuala_Lumpur': 'Asia/Brunei',
    'Asia/Kuching': 'Asia/Brunei',
    'Asia/Macau': 'Asia/Brunei',
    'Asia/Makassar': 'Asia/Brunei',
    'Asia/Manila': 'Asia/Brunei',
    'Asia/Shanghai': 'Asia/Brunei',
    'Asia/Taipei': 'Asia/Brunei',
    'Australia/Perth': 'Asia/Brunei',
    'Asia/Chita': 'Asia/Chita',
    'Asia/Choibalsan': 'Asia/Choibalsan',
    'Asia/Ulaanbaatar': 'Asia/Choibalsan',
    'Asia/Colombo': 'Asia/Colombo',
    'Asia/Kolkata': 'Asia/Colombo',
    'Asia/Damascus': 'Asia/Damascus',
    'Asia/Dili': 'Asia/Dili',
    'Asia/Jayapura': 'Asia/Dili',
    'Asia/Seoul': 'Asia/Dili',
    'Asia/Tokyo': 'Asia/Dili',
    'Pacific/Palau': 'Asia/Dili',
    'Asia/Dubai': 'Asia/Dubai',
    'Asia/Tbilisi': 'Asia/Dubai',
    'Indian/Mahe': 'Asia/Dubai',
    'Indian/Mauritius': 'Asia/Dubai',
    'Indian/Reunion': 'Asia/Dubai',
    'Asia/Famagusta': 'Asia/Famagusta',
    'Asia/Gaza': 'Asia/Gaza',
    'Asia/Hebron': 'Asia/Hebron',
    'Asia/Hovd': 'Asia/Hovd',
    'Asia/Irkutsk': 'Asia/Irkutsk',
    'Asia/Jerusalem': 'Asia/Jerusalem',
    'Asia/Kabul': 'Asia/Kabul',
    'Asia/Kathmandu': 'Asia/Kathmandu',
    'Asia/Khandyga': 'Asia/Khandyga',
    'Asia/Krasnoyarsk': 'Asia/Krasnoyarsk',
    'Asia/Magadan': 'Asia/Magadan',
    'Asia/Nicosia': 'Asia/Nicosia',
    'Europe/Athens': 'Asia/Nicosia',
    'Europe/Bucharest': 'Asia/Nicosia',
    'Europe/Helsinki': 'Asia/Nicosia',
    'Europe/Kiev': 'Asia/Nicosia',
    'Europe/Riga': 'Asia/Nicosia',
    'Europe/Sofia': 'Asia/Nicosia',
    'Europe/Tallinn': 'Asia/Nicosia',
    'Europe/Uzhgorod': 'Asia/Nicosia',
    'Europe/Vilnius': 'Asia/Nicosia',
    'Europe/Zaporozhye': 'Asia/Nicosia',
    'Asia/Novokuznetsk': 'Asia/Novokuznetsk',
    'Asia/Novosibirsk': 'Asia/Novosibirsk',
    'Asia/Omsk': 'Asia/Omsk',
    'Asia/Pyongyang': 'Asia/Pyongyang',
    'Asia/Qyzylorda': 'Asia/Qyzylorda',
    'Asia/Sakhalin': 'Asia/Sakhalin',
    'Asia/Srednekolymsk': 'Asia/Srednekolymsk',
    'Asia/Tehran': 'Asia/Tehran',
    'Asia/Tomsk': 'Asia/Tomsk',
    'Asia/Ust-Nera': 'Asia/Ust-Nera',
    'Asia/Vladivostok': 'Asia/Vladivostok',
    'Asia/Yakutsk': 'Asia/Yakutsk',
    'Asia/Yekaterinburg': 'Asia/Yekaterinburg',
    'Asia/Yerevan': 'Asia/Yerevan',
    'Atlantic/Canary': 'Atlantic/Canary',
    'Atlantic/Faroe': 'Atlantic/Canary',
    'Atlantic/Madeira': 'Atlantic/Canary',
    'Europe/Dublin': 'Atlantic/Canary',
    'Europe/Lisbon': 'Atlantic/Canary',
    'Europe/London': 'Atlantic/Canary',
    'Atlantic/Cape_Verde': 'Atlantic/Cape_Verde',
    'Atlantic/Stanley': 'Atlantic/Stanley',
    'Australia/Adelaide': 'Australia/Adelaide',
    'Australia/Broken_Hill': 'Australia/Adelaide',
    'Australia/Darwin': 'Australia/Darwin',
    'Australia/Eucla': 'Australia/Eucla',
    'Australia/Hobart': 'Australia/Hobart',
    'Australia/Melbourne': 'Australia/Hobart',
    'Australia/Sydney': 'Australia/Hobart',
    'Australia/Lord_Howe': 'Australia/Lord_Howe',
    'Europe/Astrakhan': 'Europe/Astrakhan',
    'Europe/Ulyanovsk': 'Europe/Astrakhan',
    'Europe/Chisinau': 'Europe/Chisinau',
    'Europe/Istanbul': 'Europe/Istanbul',
    'Europe/Kaliningrad': 'Europe/Kaliningrad',
    'Europe/Kirov': 'Europe/Kirov',
    'Europe/Moscow': 'Europe/Kirov',
    'Europe/Minsk': 'Europe/Minsk',
    'Europe/Samara': 'Europe/Samara',
    'Europe/Saratov': 'Europe/Saratov',
    'Europe/Simferopol': 'Europe/Simferopol',
    'Europe/Volgograd': 'Europe/Volgograd',
    'Indian/Cocos': 'Indian/Cocos',
    'Pacific/Apia': 'Pacific/Apia',
    'Pacific/Auckland': 'Pacific/Auckland',
    'Pacific/Bougainville': 'Pacific/Bougainville',
    'Pacific/Chatham': 'Pacific/Chatham',
    'Pacific/Easter': 'Pacific/Easter',
    'Pacific/Efate': 'Pacific/Efate',
    'Pacific/Guadalcanal': 'Pacific/Efate',
    'Pacific/Kosrae': 'Pacific/Efate',
    'Pacific/Noumea': 'Pacific/Efate',
    'Pacific/Pohnpei': 'Pacific/Efate',
    'Pacific/Fakaofo': 'Pacific/Fakaofo',
    'Pacific/Fiji': 'Pacific/Fiji',
    'Pacific/Gambier': 'Pacific/Gambier',
    'Pacific/Honolulu': 'Pacific/Honolulu',
    'Pacific/Rarotonga': 'Pacific/Honolulu',
    'Pacific/Tahiti': 'Pacific/Honolulu',
    'Pacific/Kiritimati': 'Pacific/Kiritimati',
    'Pacific/Kwajalein': 'Pacific/Kwajalein',
    'Pacific/Majuro': 'Pacific/Kwajalein',
    'Pacific/Nauru': 'Pacific/Kwajalein',
    'Pacific/Tarawa': 'Pacific/Kwajalein',
    'Pacific/Marquesas': 'Pacific/Marquesas',
    'Pacific/Niue': 'Pacific/Niue',
    'Pacific/Pago_Pago': 'Pacific/Niue',
    'Pacific/Norfolk': 'Pacific/Norfolk',
    'Pacific/Pitcairn': 'Pacific/Pitcairn',
    'Pacific/Tongatapu': 'Pacific/Tongatapu',
};

export const MANUAL_TIMEZONE_LINKS: { [key: string]: string } = {
    'abu dhabi, muscat': 'Asia/Muscat',
    acre: 'America/Rio_Branco',
    'adelaide, central australia': 'Australia/Adelaide',
    afghanistan: 'Asia/Kabul',
    'afghanistan standard time': 'Asia/Kabul',
    'africa central': 'Africa/Maputo',
    'africa eastern': 'Africa/Nairobi',
    'africa farwestern': 'Africa/El_Aaiun',
    'africa southern': 'Africa/Johannesburg',
    'africa western': 'Africa/Lagos',
    aktyubinsk: 'Asia/Aqtobe',
    alaska: 'America/Anchorage',
    'alaska hawaii': 'America/Anchorage',
    alaskan: 'America/Anchorage',
    'alaskan standard time': 'America/Anchorage',
    'aleutian standard time': 'America/Adak',
    almaty: 'Asia/Almaty',
    'almaty, novosibirsk, north central asia': 'Asia/Almaty',
    'altai standard time': 'Asia/Barnaul',
    amazon: 'America/Manaus',
    'america central': 'America/Chicago',
    'america eastern': 'America/New_York',
    'america mountain': 'America/Denver',
    'america pacific': 'America/Los_Angeles',
    'amsterdam, berlin, bern, rome, stockholm, vienna': 'Europe/Berlin',
    anadyr: 'Asia/Anadyr',
    apia: 'Pacific/Apia',
    aqtau: 'Asia/Aqtau',
    aqtobe: 'Asia/Aqtobe',
    arab: 'Asia/Kuwait',
    'arab standard time': 'Asia/Riyadh',
    'arab, kuwait, riyadh': 'Asia/Kuwait',
    arabian: 'Asia/Muscat',
    'arabian standard time': 'Asia/Dubai',
    arabic: 'Asia/Baghdad',
    'arabic standard time': 'Asia/Baghdad',
    argentina: 'America/Argentina/Buenos_Aires',
    'argentina standard time': 'America/Argentina/Buenos_Aires',
    'argentina western': 'America/Argentina/San_Luis',
    arizona: 'America/Phoenix',
    armenia: 'Asia/Yerevan',
    armenian: 'Asia/Yerevan',
    'armenian standard time': 'Asia/Yerevan',
    ashkhabad: 'Asia/Ashgabat',
    'astana, dhaka': 'Asia/Dhaka',
    'astrakhan standard time': 'Europe/Astrakhan',
    'athens, istanbul, minsk': 'Europe/Athens',
    atlantic: 'America/Halifax',
    'atlantic standard time': 'America/Halifax',
    'atlantic time (canada)': 'America/Halifax',
    'auckland, wellington': 'Pacific/Auckland',
    'aus central': 'Australia/Darwin',
    'aus central standard time': 'Australia/Darwin',
    'aus central w standard time': 'Australia/Eucla',
    'aus eastern': 'Australia/Sydney',
    'aus eastern standard time': 'Australia/Sydney',
    'australia central': 'Australia/Adelaide',
    'australia centralwestern': 'Australia/Eucla',
    'australia eastern': 'Australia/Sydney',
    'australia western': 'Australia/Perth',
    azerbaijan: 'Asia/Baku',
    'azerbaijan standard time': 'Asia/Baku',
    azerbijan: 'Asia/Baku',
    azores: 'Atlantic/Azores',
    'azores standard time': 'Atlantic/Azores',
    baghdad: 'Asia/Baghdad',
    'bahia standard time': 'America/Bahia',
    baku: 'Asia/Baku',
    'baku, tbilisi, yerevan': 'Asia/Baku',
    'bangkok, hanoi, jakarta': 'Asia/Bangkok',
    bangladesh: 'Asia/Dhaka',
    'bangladesh standard time': 'Asia/Dhaka',
    'beijing, chongqing, hong kong sar, urumqi': 'Asia/Shanghai',
    'belarus standard time': 'Europe/Minsk',
    'belgrade, pozsony, budapest, ljubljana, prague': 'Europe/Prague',
    bering: 'America/Adak',
    bhutan: 'Asia/Thimphu',
    'bogota, lima, quito': 'America/Bogota',
    bolivia: 'America/La_Paz',
    borneo: 'Asia/Kuching',
    'bougainville standard time': 'Pacific/Bougainville',
    brasilia: 'America/Sao_Paulo',
    'brisbane, east australia': 'Australia/Brisbane',
    british: 'Europe/London',
    brunei: 'Asia/Brunei',
    'brussels, copenhagen, madrid, paris': 'Europe/Paris',
    bucharest: 'Europe/Bucharest',
    'buenos aires': 'America/Argentina/Buenos_Aires',
    cairo: 'Africa/Cairo',
    'canada central': 'America/Edmonton',
    'canada central standard time': 'America/Regina',
    'canberra, melbourne, sydney, hobart (year 2000 only)': 'Australia/Sydney',
    'cape verde': 'Atlantic/Cape_Verde',
    'cape verde is': 'Atlantic/Cape_Verde',
    'cape verde standard time': 'Atlantic/Cape_Verde',
    'caracas, la paz': 'America/Caracas',
    'casablanca, monrovia': 'Africa/Casablanca',
    casey: 'Antarctica/Casey',
    caucasus: 'Asia/Yerevan',
    'caucasus standard time': 'Asia/Yerevan',
    'cen australia': 'Australia/Adelaide',
    'cen australia standard time': 'Australia/Adelaide',
    central: 'America/Chicago',
    'central america': 'America/Guatemala',
    'central america standard time': 'America/Guatemala',
    'central asia': 'Asia/Dhaka',
    'central asia standard time': 'Asia/Almaty',
    'central brazilian': 'America/Manaus',
    'central brazilian standard time': 'America/Cuiaba',
    'central europe': 'Europe/Prague',
    'central europe standard time': 'Europe/Budapest',
    'central european': 'Europe/Sarajevo',
    'central european standard time': 'Europe/Warsaw',
    'central pacific': 'Asia/Magadan',
    'central pacific standard time': 'Pacific/Guadalcanal',
    'central standard time': 'America/Chicago',
    'central standard time (mexico)': 'America/Mexico_City',
    'central time (us & canada)': 'America/Chicago',
    chamorro: 'Pacific/Saipan',
    chatham: 'Pacific/Chatham',
    'chatham islands standard time': 'Pacific/Chatham',
    chile: 'America/Santiago',
    china: 'Asia/Shanghai',
    'china standard time': 'Asia/Shanghai',
    choibalsan: 'Asia/Choibalsan',
    christmas: 'Indian/Christmas',
    cocos: 'Indian/Cocos',
    colombia: 'America/Bogota',
    cook: 'Pacific/Rarotonga',
    cuba: 'America/Havana',
    'cuba standard time': 'America/Havana',
    dacca: 'Asia/Dhaka',
    darwin: 'Australia/Darwin',
    dateline: 'Pacific/Auckland',
    'dateline standard time': 'Pacific/Niue',
    davis: 'Antarctica/Davis',
    dominican: 'America/Santo_Domingo',
    dumontdurville: 'Antarctica/DumontDUrville',
    dushanbe: 'Asia/Dushanbe',
    'dutch guiana': 'America/Paramaribo',
    'e africa': 'Africa/Nairobi',
    'e africa standard time': 'Africa/Nairobi',
    'e australia': 'Australia/Brisbane',
    'e australia standard time': 'Australia/Brisbane',
    'e europe': 'Europe/Minsk',
    'e europe standard time': 'Europe/Chisinau',
    'e south america': 'America/Belem',
    'e south america standard time': 'America/Sao_Paulo',
    'east africa, nairobi': 'Africa/Nairobi',
    'east timor': 'Asia/Dili',
    easter: 'Pacific/Easter',
    'easter island standard time': 'Pacific/Easter',
    eastern: 'America/New_York',
    'eastern standard time': 'America/New_York',
    'eastern standard time (mexico)': 'America/Cancun',
    'eastern time (us & canada)': 'America/New_York',
    ecuador: 'America/Guayaquil',
    egypt: 'Africa/Cairo',
    'egypt standard time': 'Africa/Cairo',
    ekaterinburg: 'Asia/Yekaterinburg',
    'ekaterinburg standard time': 'Asia/Yekaterinburg',
    'eniwetok, kwajalein, dateline time': 'Pacific/Kwajalein',
    'europe central': 'Europe/Paris',
    'europe eastern': 'Europe/Bucharest',
    'europe further eastern': 'Europe/Minsk',
    'europe western': 'Atlantic/Canary',
    falkland: 'Atlantic/Stanley',
    fiji: 'Pacific/Fiji',
    'fiji islands standard time': 'Pacific/Fiji',
    'fiji islands, kamchatka, marshall is': 'Pacific/Fiji',
    'fiji standard time': 'Pacific/Fiji',
    fle: 'Europe/Helsinki',
    'fle standard time': 'Europe/Kiev',
    'french guiana': 'America/Cayenne',
    'french southern': 'Indian/Kerguelen',
    frunze: 'Asia/Bishkek',
    galapagos: 'Pacific/Galapagos',
    gambier: 'Pacific/Gambier',
    georgia: 'Asia/Tbilisi',
    georgian: 'Asia/Tbilisi',
    'georgian standard time': 'Asia/Tbilisi',
    'gilbert islands': 'Pacific/Tarawa',
    gmt: 'Europe/London',
    'gmt standard time': 'Europe/London',
    'goose bay': 'America/Goose_Bay',
    greenland: 'Atlantic/Stanley',
    'greenland central': 'America/Scoresbysund',
    'greenland eastern': 'America/Scoresbysund',
    'greenland standard time': 'Atlantic/Stanley',
    'greenland western': 'Atlantic/Stanley',
    greenwich: 'Atlantic/Reykjavik',
    'greenwich mean time; dublin, edinburgh, london': 'Europe/London',
    'greenwich mean time: dublin, edinburgh, lisbon, london': 'Europe/Lisbon',
    'greenwich standard time': 'Atlantic/Reykjavik',
    gtb: 'Europe/Athens',
    'gtb standard time': 'Europe/Bucharest',
    guam: 'Pacific/Guam',
    'guam, port moresby': 'Pacific/Guam',
    gulf: 'Asia/Dubai',
    guyana: 'America/Guyana',
    'haiti standard time': 'America/Port-au-Prince',
    'harare, pretoria': 'Africa/Harare',
    hawaii: 'Pacific/Honolulu',
    'hawaii aleutian': 'Pacific/Honolulu',
    hawaiian: 'Pacific/Honolulu',
    'hawaiian standard time': 'Pacific/Honolulu',
    'helsinki, riga, tallinn': 'Europe/Helsinki',
    'hobart, tasmania': 'Australia/Hobart',
    'hong kong': 'Asia/Hong_Kong',
    hovd: 'Asia/Hovd',
    india: 'Asia/Kolkata',
    'india standard time': 'Asia/Kolkata',
    'indian ocean': 'Indian/Chagos',
    'indiana (east)': 'America/Indiana/Indianapolis',
    indochina: 'Asia/Bangkok',
    'indonesia central': 'Asia/Makassar',
    'indonesia eastern': 'Asia/Jayapura',
    'indonesia western': 'Asia/Jakarta',
    iran: 'Asia/Tehran',
    'iran standard time': 'Asia/Tehran',
    irish: 'Europe/Dublin',
    irkutsk: 'Asia/Irkutsk',
    'irkutsk, ulaan bataar': 'Asia/Irkutsk',
    'islamabad, karachi, tashkent': 'Asia/Karachi',
    israel: 'Asia/Jerusalem',
    'israel standard time': 'Asia/Jerusalem',
    'israel, jerusalem standard time': 'Asia/Jerusalem',
    japan: 'Asia/Tokyo',
    jordan: 'Asia/Amman',
    'jordan standard time': 'Asia/Amman',
    kabul: 'Asia/Kabul',
    'kaliningrad standard time': 'Europe/Kaliningrad',
    kamchatka: 'Asia/Kamchatka',
    'kamchatka standard time': 'Asia/Kamchatka',
    karachi: 'Asia/Karachi',
    'kathmandu, nepal': 'Asia/Kathmandu',
    'kazakhstan eastern': 'Asia/Almaty',
    'kazakhstan western': 'Asia/Aqtobe',
    kizilorda: 'Asia/Qyzylorda',
    'kolkata, chennai, mumbai, new delhi, india standard time': 'Asia/Kolkata',
    korea: 'Asia/Seoul',
    'korea standard time': 'Asia/Seoul',
    kosrae: 'Pacific/Kosrae',
    krasnoyarsk: 'Asia/Krasnoyarsk',
    'kuala lumpur, singapore': 'Asia/Shanghai',
    kuybyshev: 'Europe/Samara',
    kwajalein: 'Pacific/Kwajalein',
    kyrgystan: 'Asia/Bishkek',
    lanka: 'Asia/Colombo',
    liberia: 'Africa/Monrovia',
    'libya standard time': 'Africa/Tripoli',
    'line islands': 'Pacific/Kiritimati',
    'line islands standard time': 'Pacific/Kiritimati',
    'lord howe': 'Australia/Lord_Howe',
    'lord howe standard time': 'Australia/Lord_Howe',
    macau: 'Asia/Macau',
    macquarie: 'Antarctica/Macquarie',
    magadan: 'Asia/Magadan',
    'magadan standard time': 'Asia/Magadan',
    'magadan, solomon is, new caledonia': 'Asia/Magadan',
    'magallanes standard time': 'America/Punta_Arenas',
    malaya: 'Asia/Kuala_Lumpur',
    malaysia: 'Asia/Kuching',
    maldives: 'Indian/Maldives',
    marquesas: 'Pacific/Marquesas',
    'marquesas standard time': 'Pacific/Marquesas',
    'marshall islands': 'Pacific/Majuro',
    mauritius: 'Indian/Mauritius',
    'mauritius standard time': 'Indian/Mauritius',
    mawson: 'Antarctica/Mawson',
    mexico: 'America/Mexico_City',
    'mexico city, tegucigalpa': 'America/Mexico_City',
    'mexico pacific': 'America/Mazatlan',
    'mexico standard time': 'America/Mexico_City',
    'mexico standard time 2': 'America/Chihuahua',
    'mid-atlantic': 'America/Noronha',
    'mid-atlantic standard time': 'Atlantic/Cape_Verde',
    'middle east': 'Asia/Beirut',
    'middle east standard time': 'Asia/Beirut',
    'midway island, samoa': 'Pacific/Midway',
    mongolia: 'Asia/Ulaanbaatar',
    montevideo: 'America/Montevideo',
    'montevideo standard time': 'America/Montevideo',
    morocco: 'Africa/Casablanca',
    'morocco standard time': 'Africa/Casablanca',
    moscow: 'Europe/Moscow',
    'moscow, st petersburg, volgograd': 'Europe/Moscow',
    mountain: 'America/Denver',
    'mountain standard time': 'America/Denver',
    'mountain standard time (mexico)': 'America/Chihuahua',
    'mountain time (us & canada)': 'America/Denver',
    myanmar: 'Indian/Cocos',
    'myanmar standard time': 'Indian/Cocos',
    'n central asia': 'Asia/Almaty',
    'n central asia standard time': 'Asia/Novosibirsk',
    namibia: 'Africa/Windhoek',
    'namibia standard time': 'Africa/Windhoek',
    nauru: 'Pacific/Nauru',
    nepal: 'Asia/Kathmandu',
    'nepal standard time': 'Asia/Kathmandu',
    'new caledonia': 'Pacific/Noumea',
    'new zealand': 'Pacific/Auckland',
    'new zealand standard time': 'Pacific/Auckland',
    newfoundland: 'America/St_Johns',
    'newfoundland and labrador standard time': 'America/St_Johns',
    'newfoundland standard time': 'America/St_Johns',
    niue: 'Pacific/Niue',
    norfolk: 'Pacific/Norfolk',
    'norfolk standard time': 'Pacific/Norfolk',
    noronha: 'America/Noronha',
    'north asia': 'Asia/Krasnoyarsk',
    'north asia east': 'Asia/Irkutsk',
    'north asia east standard time': 'Asia/Irkutsk',
    'north asia standard time': 'Asia/Krasnoyarsk',
    'north korea standard time': 'Asia/Pyongyang',
    'north mariana': 'Pacific/Saipan',
    novosibirsk: 'Asia/Novosibirsk',
    "nuku'alofa, tonga": 'Pacific/Tongatapu',
    omsk: 'Asia/Omsk',
    'omsk standard time': 'Asia/Omsk',
    oral: 'Asia/Oral',
    'osaka, sapporo, tokyo': 'Asia/Tokyo',
    pacific: 'America/Los_Angeles',
    'pacific sa': 'America/Santiago',
    'pacific sa standard time': 'America/Santiago',
    'pacific standard time': 'America/Los_Angeles',
    'pacific standard time (mexico)': 'America/Tijuana',
    'pacific time (us & canada)': 'America/Los_Angeles',
    'pacific time (us & canada); tijuana': 'America/Los_Angeles',
    pakistan: 'Asia/Karachi',
    'pakistan standard time': 'Asia/Karachi',
    palau: 'Pacific/Palau',
    'papua new guinea': 'Pacific/Port_Moresby',
    paraguay: 'America/Asuncion',
    'paraguay standard time': 'America/Asuncion',
    'paris, madrid, brussels, copenhagen': 'Europe/Paris',
    'perth, western australia': 'Australia/Perth',
    peru: 'America/Lima',
    philippines: 'Asia/Manila',
    'phoenix islands': 'Pacific/Fakaofo',
    'pierre miquelon': 'America/Miquelon',
    pitcairn: 'Pacific/Pitcairn',
    'prague, central europe': 'Europe/Prague',
    pyongyang: 'Asia/Pyongyang',
    qyzylorda: 'Asia/Qyzylorda',
    'qyzylorda standard time': 'Asia/Qyzylorda',
    rangoon: 'Indian/Cocos',
    reunion: 'Indian/Reunion',
    romance: 'Europe/Paris',
    'romance standard time': 'Europe/Paris',
    rothera: 'Antarctica/Rothera',
    'russia time zone 10': 'Asia/Srednekolymsk',
    'russia time zone 11': 'Asia/Kamchatka',
    'russia time zone 3': 'Europe/Samara',
    russian: 'Europe/Moscow',
    'russian standard time': 'Europe/Moscow',
    'sa eastern': 'America/Belem',
    'sa eastern standard time': 'America/Cayenne',
    'sa pacific': 'America/Bogota',
    'sa pacific standard time': 'America/Bogota',
    'sa western': 'America/La_Paz',
    'sa western standard time': 'America/La_Paz',
    'saint pierre standard time': 'America/Miquelon',
    sakhalin: 'Asia/Sakhalin',
    'sakhalin standard time': 'Asia/Sakhalin',
    samara: 'Europe/Samara',
    samarkand: 'Asia/Samarkand',
    samoa: 'Pacific/Apia',
    'samoa standard time': 'Pacific/Apia',
    santiago: 'America/Santiago',
    'sao tome standard time': 'Africa/Sao_Tome',
    'sarajevo, skopje, sofija, vilnius, warsaw, zagreb': 'Europe/Sarajevo',
    'saratov standard time': 'Europe/Saratov',
    saskatchewan: 'America/Edmonton',
    'se asia': 'Asia/Bangkok',
    'se asia standard time': 'Asia/Bangkok',
    'seoul, korea standard time': 'Asia/Seoul',
    seychelles: 'Indian/Mahe',
    shevchenko: 'Asia/Aqtau',
    singapore: 'Asia/Shanghai',
    'singapore standard time': 'Asia/Shanghai',
    solomon: 'Pacific/Guadalcanal',
    'south africa': 'Africa/Harare',
    'south africa standard time': 'Africa/Johannesburg',
    'south georgia': 'Atlantic/South_Georgia',
    'sri jayawardenepura, sri lanka': 'Asia/Colombo',
    'sri lanka': 'Asia/Colombo',
    'sri lanka standard time': 'Asia/Colombo',
    'sudan standard time': 'Africa/Khartoum',
    suriname: 'America/Paramaribo',
    sverdlovsk: 'Asia/Yekaterinburg',
    syowa: 'Antarctica/Syowa',
    'syria standard time': 'Asia/Damascus',
    tahiti: 'Pacific/Tahiti',
    taipei: 'Asia/Taipei',
    'taipei standard time': 'Asia/Taipei',
    tajikistan: 'Asia/Dushanbe',
    tashkent: 'Asia/Tashkent',
    tasmania: 'Australia/Hobart',
    'tasmania standard time': 'Australia/Hobart',
    tbilisi: 'Asia/Tbilisi',
    tehran: 'Asia/Tehran',
    'tocantins standard time': 'America/Araguaina',
    tokelau: 'Pacific/Fakaofo',
    tokyo: 'Asia/Tokyo',
    'tokyo standard time': 'Asia/Tokyo',
    'tomsk standard time': 'Asia/Tomsk',
    tonga: 'Pacific/Tongatapu',
    'tonga standard time': 'Pacific/Tongatapu',
    'transbaikal standard time': 'Asia/Chita',
    'transitional islamic state of afghanistan standard time': 'Asia/Kabul',
    turkey: 'Europe/Istanbul',
    'turkey standard time': 'Europe/Istanbul',
    turkmenistan: 'Asia/Ashgabat',
    'turks and caicos standard time': 'America/Grand_Turk',
    tuvalu: 'Pacific/Funafuti',
    'ulaanbaatar standard time': 'Asia/Ulaanbaatar',
    'universal coordinated time': 'UTC',
    uralsk: 'Asia/Oral',
    uruguay: 'America/Montevideo',
    urumqi: 'Asia/Urumqi',
    'us eastern': 'America/Indiana/Indianapolis',
    'us eastern standard time': 'America/New_York',
    'us mountain': 'America/Phoenix',
    'us mountain standard time': 'America/Phoenix',
    utc: 'UTC',
    'utc-02': 'America/Noronha',
    'utc-08': 'Pacific/Pitcairn',
    'utc-09': 'Pacific/Gambier',
    'utc-11': 'Pacific/Niue',
    'utc+12': 'Pacific/Auckland',
    'utc+13': 'Pacific/Fakaofo',
    uzbekistan: 'Asia/Tashkent',
    vanuatu: 'Pacific/Efate',
    venezuela: 'America/Caracas',
    'venezuela standard time': 'America/Caracas',
    vladivostok: 'Asia/Vladivostok',
    'vladivostok standard time': 'Asia/Vladivostok',
    volgograd: 'Europe/Volgograd',
    'volgograd standard time': 'Europe/Volgograd',
    vostok: 'Antarctica/Vostok',
    'w australia': 'Australia/Perth',
    'w australia standard time': 'Australia/Perth',
    'w central africa': 'Africa/Lagos',
    'w central africa standard time': 'Africa/Lagos',
    'w europe': 'Europe/Amsterdam',
    'w europe standard time': 'Europe/Berlin',
    'w mongolia standard time': 'Asia/Hovd',
    wake: 'Pacific/Wake',
    wallis: 'Pacific/Wallis',
    'west asia': 'Asia/Tashkent',
    'west asia standard time': 'Asia/Tashkent',
    'west bank standard time': 'Asia/Hebron',
    'west central africa': 'Africa/Luanda',
    'west pacific': 'Pacific/Guam',
    'west pacific standard time': 'Pacific/Port_Moresby',
    yakutsk: 'Asia/Yakutsk',
    'yakutsk standard time': 'Asia/Yakutsk',
    yekaterinburg: 'Asia/Yekaterinburg',
    yerevan: 'Asia/Yerevan',
    yukon: 'America/Yakutat',
    'coordinated universal time-11': 'Pacific/Pago_Pago',
    'aleutian islands': 'America/Adak',
    'marquesas islands': 'Pacific/Marquesas',
    'coordinated universal time-09': 'America/Anchorage',
    'baja california': 'America/Tijuana',
    'coordinated universal time-08': 'Pacific/Pitcairn',
    'chihuahua, la paz, mazatlan': 'America/Chihuahua',
    'easter island': 'Pacific/Easter',
    'guadalajara, mexico city, monterrey': 'America/Mexico_City',
    'bogota, lima, quito, rio branco': 'America/Bogota',
    chetumal: 'America/Cancun',
    haiti: 'America/Port-au-Prince',
    havana: 'America/Havana',
    'turks and caicos': 'America/Grand_Turk',
    asuncion: 'America/Asuncion',
    caracas: 'America/Caracas',
    cuiaba: 'America/Cuiaba',
    'georgetown, la paz, manaus, san juan': 'America/La_Paz',
    araguaina: 'America/Araguaina',
    'cayenne, fortaleza': 'America/Cayenne',
    'city of buenos aires': 'America/Argentina/Buenos_Aires',
    'punta arenas': 'America/Punta_Arenas',
    'saint pierre and miquelon': 'America/Miquelon',
    salvador: 'America/Bahia',
    'coordinated universal time-02': 'America/Noronha',
    'mid-atlantic - old': 'America/Noronha',
    'cabo verde is': 'Atlantic/Cape_Verde',
    'coordinated universal time': 'UTC',
    'dublin, edinburgh, lisbon, london': 'Europe/London',
    'monrovia, reykjavik': 'Atlantic/Reykjavik',
    'belgrade, bratislava, budapest, ljubljana, prague': 'Europe/Budapest',
    casablanca: 'Africa/Casablanca',
    'sao tome': 'Africa/Sao_Tome',
    'sarajevo, skopje, warsaw, zagreb': 'Europe/Warsaw',
    amman: 'Asia/Amman',
    'athens, bucharest': 'Europe/Bucharest',
    beirut: 'Asia/Beirut',
    chisinau: 'Europe/Chisinau',
    damascus: 'Asia/Damascus',
    'gaza, hebron': 'Asia/Hebron',
    jerusalem: 'Asia/Jerusalem',
    kaliningrad: 'Europe/Kaliningrad',
    khartoum: 'Africa/Khartoum',
    tripoli: 'Africa/Tripoli',
    windhoek: 'Africa/Windhoek',
    istanbul: 'Europe/Istanbul',
    'kuwait, riyadh': 'Asia/Riyadh',
    minsk: 'Europe/Minsk',
    'moscow, st petersburg': 'Europe/Moscow',
    nairobi: 'Africa/Nairobi',
    'astrakhan, ulyanovsk': 'Europe/Astrakhan',
    'izhevsk, samara': 'Europe/Samara',
    'port louis': 'Indian/Mauritius',
    saratov: 'Europe/Saratov',
    'ashgabat, tashkent': 'Asia/Tashkent',
    'islamabad, karachi': 'Asia/Karachi',
    'chennai, kolkata, mumbai, new delhi': 'Asia/Kolkata',
    'sri jayawardenepura': 'Asia/Colombo',
    kathmandu: 'Asia/Kathmandu',
    astana: 'Asia/Almaty',
    dhaka: 'Asia/Dhaka',
    'yangon (rangoon)': 'Indian/Cocos',
    'barnaul, gorno-altaysk': 'Asia/Barnaul',
    tomsk: 'Asia/Tomsk',
    'beijing, chongqing, hong kong, urumqi': 'Asia/Shanghai',
    perth: 'Australia/Perth',
    ulaanbaatar: 'Asia/Ulaanbaatar',
    eucla: 'Australia/Eucla',
    chita: 'Asia/Chita',
    seoul: 'Asia/Seoul',
    adelaide: 'Australia/Adelaide',
    brisbane: 'Australia/Brisbane',
    'canberra, melbourne, sydney': 'Australia/Sydney',
    hobart: 'Australia/Hobart',
    'lord howe island': 'Australia/Lord_Howe',
    'bougainville island': 'Pacific/Bougainville',
    chokurdakh: 'Asia/Srednekolymsk',
    'norfolk island': 'Pacific/Norfolk',
    'solomon is, new caledonia': 'Pacific/Guadalcanal',
    'anadyr, petropavlovsk-kamchatsky': 'Asia/Kamchatka',
    'coordinated universal time+12': 'Pacific/Tarawa',
    'petropavlovsk-kamchatsky - old': 'Asia/Anadyr',
    'chatham islands': 'Pacific/Chatham',
    'coordinated universal time+13': 'Pacific/Fakaofo',
    "nuku'alofa": 'Pacific/Tongatapu',
    'kiritimati island': 'Pacific/Kiritimati',
    'helsinki, kyiv, riga, sofia, tallinn, vilnius': 'Europe/Helsinki',
};

/**
 * This is a "hack" function that tries to transform IANA time zones detected by the browser into
 * one supported by us. Returns undefined if no conversion is available
 */
export const manualFindTimeZone = (tzid: string) => {
    return MANUAL_TIMEZONE_LINKS[tzid.toLowerCase()];
};
